/** A result line under a control, announced through its aria-live region. */
export interface OEPStatusLine { Text: string; Tone: 'ok' | 'error'; Link?: { Label: string; Url: string } }

/** Client-side cap on a thread message or thank-you note (V052 caps the thank-you at 2000; the brief uses 2000 for both). */
export const OEP_NOTE_MAX = 2000;
